








































































































































































































































































































































































import Vue from 'vue';
import { getEvent,getEventGuestCategoryQuestions } from '@/modules/event/event.service';
import { getEventsPaymentOptions } from '@/modules/event/payment-options.service';
import { postSubscriptionWithGuestsAndAnswers,putSubscriptionWithGuestsAndAnswers,patchSubscriptionCheckIn,getSubscription,getRecentSubscriptionsForEventCategory } from '@/modules/event/subscription.service';
import { AnswerModel,GuestModel,SubscriptionModel } from '@/modules/event/subscription.input';
import { verify } from '@/modules/google-captcha.service';
//import VueRecaptcha from 'vue-recaptcha';
import { VueReCaptcha } from 'vue-recaptcha-v3';
//import SumUpCard from '@/assets/js/vendor/sumup.sdk.js'
import SubscriptionPaymentDetails from '@/components/SubscriptionPaymentDetails';
import moment from 'moment';

Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA_V3_SITE_KEY });

export default Vue.extend({
  components: { SubscriptionPaymentDetails },
  data () {
    return {
      isAdmin : false,
      editionMode: false,
      showBottomBackToEventButton: false,
      saveButtonLabel: 'Envoyer l\'inscription',
      eventId : 0,
      subscriptionId: 0,
      event: {
        id: 0,
        name: '',
        date: '',
        description: '',
        subscriptionOpen: true,
        paymentEnabled:false
      },
      eventError: '',
      subscription: {
        id: 0,
        guestCategories: [],
        firstName: '',
        lastName: '',
        email: '',
        phonenumber: '',
        organization: '',
        paymentOptionsId: 0,
        paymentStatus: 'TOPROCESS',
        paymentRef: '',
        paymentAmount: 0,
        checkedIn: false
      },
      totalGuestsCounter: 0,
      subscriptionError: '',
      paymentMessage: '',
      guestCategories: [] as any[],
      cacheGuestCategoriesQuestions: {},
      cacheAnswers: {},
      cacheGuestIdsToDelete: [],
      cacheAnswerIdsToDelete: [],
      successMessage: '',
      checkedInOk: false,
      meta: {
        title: "Formulaire d'inscription"
      },
      dataToSend : {},
      numberGuestsCounter: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],
      categorySelectionCounter: 0,
      confirmDialog: false,
      dialogError: '',
      findPreviousSubscriptionDialog: false,
      selectedPassedSubscription : {},
      selectedPassedSubscriptionId: 0,
      passedSubscriptions: [],
      feeSelectedIndex: 0,
      paymentOptions: [],
      openSumupWidget: false,
      sumupInstance: null,
      checkoutId: '',
      //recaptchaSiteKey:process.env.VUE_APP_RECAPTCHA_V2_SITE_KEY
    }
  },
  computed: {
    eventPassed(){
      let eventDate = new Date(this.event.date);
      eventDate = new Date(eventDate.getFullYear(),eventDate.getMonth() , eventDate.getDate());
      const today = new Date(new Date().getFullYear(),new Date().getMonth() , new Date().getDate());
      
      return (eventDate.getTime() < today.getTime()) ;
    },
    eventFees(){
      return this.guest.questions.filter(question => question.type === 'PAYMENT');
    },
    paymentOptionType(){
      if (!this.subscription.paymentOptionsId) return '';
      return this.paymentOptions.find(paymentOption => paymentOption.id === this.subscription.paymentOptionsId)?.type || '';
    },
    paymentOptionLabel(){
      if (!this.subscription.paymentOptionsId) return '';
      return this.paymentOptions.find(paymentOption => paymentOption.id === this.subscription.paymentOptionsId)?.label || '';
    },
    totalFeeAmount(){
      if (!this.event.paymentEnabled) return 0
      let total = 0;
      this.subscription.guestCategories?.forEach(category => {
        category.guests?.forEach(guest => {
          const question = guest.questions[guest.feeSelectedIndex]
          if (question.type === "FEES")
            total += parseInt(question.priceValue)
        })
      })
      return total;
    }
  },
  methods: {
    updatePaymentStatus(status: string) { 
      this.subscription.paymentStatus = status;
    },
    updatePaymentRef(ref: string) { 
      this.subscription.paymentRef = ref;
    },
    printDate(date){
      const d = new Date(date);
      return ((d.getDate()<10)?'0'+d.getDate():d.getDate())
      + '/'+((d.getMonth()<9)?'0'+(d.getMonth()+1):(d.getMonth()+1))
      + '/'+d.getFullYear();
    },
    customSubscriptionFilter (item, queryText, itemText) {
      return (item.firstName.toLowerCase().includes(queryText.toLowerCase()) 
      || item.lastName.toLowerCase().includes(queryText.toLowerCase()))
    },
    async findPassedSubscriptions(){
      getRecentSubscriptionsForEventCategory(this.event.eventCategoryId).then(res => {
          if (res.data){
            this.passedSubscriptions = res.data;
          }else if (res.error){
            this.dialogError = 'Aucune inscription passée trouvée';
          }
        });
    },
    async openFindSubscriptionDialog(){
      await this.findPassedSubscriptions();
      this.findPreviousSubscriptionDialog = true;
    },
    setSubscription(id){
      this.selectedPassedSubscription = this.passedSubscriptions.find(subs => subs.id ==  id);
    },
    fillForm(){
      if (this.selectedPassedSubscription.id){
        if (this.selectedPassedSubscription) {
          this.fillSubscriptionForm(this.selectedPassedSubscription,true);
          this.selectedPassedSubscription.formFilled = true;
        }
      }
      this.findPreviousSubscriptionDialog = false;
    },
    backToEvent(){
      this.$router.push('/evenement/gestion?id='+this.eventId);
    },
    backToSubscribedList(){
      if (this.event.paymentEnabled){
        this.$router.push('/evenement/gestion/inscrits-detail?id='+this.eventId);
      }else{
        this.$router.push('/evenement/gestion/inscrits?id='+this.eventId);
      }
    },
    checkIn(){
      if (this.subscriptionId != 0){
        patchSubscriptionCheckIn(this.subscriptionId).then(res => {
          if (res.data){
            this.successMessage = this.totalGuestsCounter + ' Personnes présentes';
            this.checkedInOk = true;
            this.subscription.checkedIn = true;
          }else if (res.error){
            this.subscriptionError = 'Erreur dans la modification de l\'inscription';
          }
        });
      }else{
        this.msgError = 'Erreur : aucune inscription trouvée pour enregistrement';
      }
    },
    validEmail(email: string) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validPhone(phonenumber: string){
      const re=/^[0-9]+$|^\+[0-9]+$/;
      return re.test(phonenumber);
    },
    validForm(){
      if (this.totalGuestsCounter <= 0){
        this.subscriptionError = 'Veuillez renseigner au moins une personne';
        return false;
      }
      if (!this.subscription.firstName || !this.subscription.lastName){
        this.subscriptionError = 'Merci de renseigner votre nom et prenom de contact';
        return false;
      }
      if (!this.subscription.email && !this.subscription.phonenumber){
        this.subscriptionError = 'Merci de renseigner votre addresse email ou numéro de téléphone.';
        return false;
      }else if (this.subscription.email && !this.validEmail(this.subscription.email)){
        this.subscriptionError = 'Le format de l\'addresse mail renseigné n\'est pas valide';
        return false;
      }else if (this.subscription.phonenumber && !this.validPhone(this.subscription.phonenumber)){
        this.subscriptionError = 'Le format du numéro de téléphone renseigné n\'est pas valide.  Si hors France veuillez renseigner le code pays devant (+321234567890 pour BE)';
        return false;
      }else if (!this.subscription.paymentOptionsId || this.subscription.paymentOptionsId==0){
        this.subscriptionError = 'Veuiller choisir un mode de reglements';
        return false;
      }
      
      return true;
    },
    async verifyAndSendForm(){
      if (this.validForm()){
        await this.sendForm();
      }
    },
    async sendForm(){
      if (!this.isAdmin && this.isAdmin){
        // (optional) Wait until recaptcha has been loaded.
          await this.$recaptchaLoaded()

          // Execute reCAPTCHA with action "login".
          const token = await this.$recaptcha('inscription');
          await verify(token).then(async response => {
            if (response.data.success && response.data.score > 0.5){
              await this.sendSubscription();
            }else {
              this.subscriptionError = "Désolé, vous semblez être un robot ? S'il s'agit d'une erreur veuillez réessayer. Si le problème persiste contactez nous directement. Merci"
            }
          });
          return null;
        }else{
          await this.sendSubscription();
        }
    },
    async sendSubscription(): Promise<any> {
      const dataToSend: SubscriptionModel = {
        id: this.subscription.id?this.subscription.id:0,
        email:  this.subscription.email?this.subscription.email:'',
        phoneNumber: this.subscription.phonenumber?this.subscription.phonenumber:'',
        firstName:  this.subscription.firstName?this.subscription.firstName:'',
        lastName:  this.subscription.lastName?this.subscription.lastName:'',
        eventId: this.event.id,
        guests: [],
        checkedIn: this.subscription.checkedIn,
        organization: this.subscription.organization?this.subscription.organization:'',
        paymentOptionsId: this.subscription.paymentOptionsId,
        paymentStatus: this.subscription.paymentStatus,
        paymentRef: this.subscription.paymentRef,
        paymentAmount: this.totalFeeAmount
      };

      for(const i in this.subscription.guestCategories) {
        const thisGuestCategory = this.subscription.guestCategories[i];
        
        for(const j in thisGuestCategory.guests) {
          const thisGuest = thisGuestCategory.guests[j];
          
          const dataGuest: GuestModel = {
            id: thisGuest.id?thisGuest.id:0,
            firstName: thisGuest.firstname?thisGuest.firstname:'',
            lastName: thisGuest.lastname?thisGuest.lastname:'',
            guestCategoryId: thisGuestCategory.id,
            answers: []
          };

          for(const k in thisGuest.questions) {
            const thisQuestion = thisGuest.questions[k];
            // convert thisAnswer to string
            let thisAnswer = thisQuestion.answer?thisQuestion.answer:'';
            if(typeof thisAnswer === 'boolean') {
              if(thisAnswer === true) {
                thisAnswer = 'true';
              } else {
                thisAnswer = 'false';
              }
            }

            if(thisQuestion.type === 'FEES')
              if(thisGuest.feeSelectedIndex == k) {
                  thisAnswer = `${thisQuestion.priceValue}`;
              } else {
                  thisAnswer = "0";
              }

            const dataAnswer: AnswerModel = {
              id: thisQuestion.answerId,
              answer: thisAnswer,
              questionId: thisQuestion.questionId,
            };

            if (thisQuestion.answerId == 0) delete dataAnswer.id;

            dataGuest.answers.push(dataAnswer);                  
          }
          if(thisGuest.id == 0) delete dataGuest.id;
          dataToSend.guests.push(dataGuest);          
        }
      }
      this.dataToSend = dataToSend;

      if(this.subscription.id > 0) {
        //PATCH route
        await putSubscriptionWithGuestsAndAnswers(dataToSend).then(async res => {
          if(res.data) {
            if (this.isAdmin){
              const props = this.$router.resolve({ 
                name: 'Gestion événément',
                query: { "id": this.eventId },
              });
              this.subscriptionError = '';
              this.successMessage = 'Modification réalisé avec succès';
              this.showBottomBackToEventButton=true;
              this.confirmDialog= true; 
            }else /*if(!this.event.paymentEnabled)*/{
              this.$router.push('inscriptionValidee?id_event='+this.eventId+'&id_subscription='+res.data.id+'&edition=true');
            }
          } else if(res.error) {
            this.subscriptionError = "Erreur à l'envoi de l'inscription. Si le problème persiste veuillez informer le sécretariat."
          }
        });
      }else{
        delete dataToSend.id
        //POST route
        //if form has been filled with previous data, delete ids
        if (this.selectedPassedSubscription.formFilled){
          for (const guest of dataToSend.guests){
            delete guest.id;
            for (const answer of guest.answers){
              delete answer.id;
            }
          }
        }
        await postSubscriptionWithGuestsAndAnswers(dataToSend).then(async res => {
          if(res.data) {
            this.checkoutId = res.data?.paymentRef ? res.data?.paymentRef : '';
            if (this.isAdmin){
              const props = this.$router.resolve({ 
                name: 'Gestion événément',
                query: { "id": this.eventId },
              });
              this.successMessage = 'Nouvelle inscription enregistré avec succès'; 
              this.subscriptionError = ''; 
              this.showBottomBackToEventButton=true;
              this.confirmDialog= true;              
            }else /*if(!this.event.paymentEnabled)*/{
              this.$router.push('inscriptionValidee?id_event='+this.eventId+'&id_subscription='+res.data.id);  
            }            
            //this.$router.push("InscriptionValidee");
          } else if(res.error) {
            this.subscriptionError = "Erreur à la modification de l'inscription. Si le problème persiste veuillez informer le sécretariat."
          }
        });
      }
    },
    deleteGuest(guestCategoryIndex: number,guestIndex: number): any{
      this.subscription.guestCategories[guestCategoryIndex].guests.splice(guestIndex,1);
      this.subscription.guestCategories[guestCategoryIndex].number--;
      this.totalGuestsCounter--;
      this.updateFormInscription();
    },
    updateFormInscription(): any {
      this.categorySelectionCounter++;
      for(const i in this.subscription.guestCategories) {
        if(this.subscription.guestCategories[i].guests.length > this.subscription.guestCategories[i].number) {
          // get list of guest ID to delete
          const guestsToDelete = this.subscription.guestCategories[i].guests.slice(this.subscription.guestCategories[i].number);
          for(const j in guestsToDelete) {
            if(guestsToDelete[j].id > 0) {
              this.cacheGuestIdsToDelete.push(guestsToDelete[j].id);
              
              for(const k in guestsToDelete[j].questions) {
                this.cacheAnswerIdsToDelete.push(guestsToDelete[j].questions[k].answerId);
              }
            }
            this.totalGuestsCounter--;
          }
          
          this.subscription.guestCategories[i].guests = this.subscription.guestCategories[i].guests.slice(0, this.subscription.guestCategories[i].number);
        }
        
        if(this.subscription.guestCategories[i].guests.length < this.subscription.guestCategories[i].number) {
          const c = this.subscription.guestCategories[i].number - this.subscription.guestCategories[i].guests.length;
          
          for(let j = 0; j < c; j++) {
            this.subscription.guestCategories[i].guests.push(this.generateGuestObject(this.subscription.guestCategories[i].id));
            this.totalGuestsCounter++;
          }
        }
        
        // this.$forceUpdate();  // @note: I didn't find anything better than this line to fix the rendering. (For now...)
      }
    },
    generateGuestObject(guestCategoryId: number, guestObject: object): any {
      const guestQuestions = [];
      const cacheListQuestions = this.cacheGuestCategoriesQuestions[guestCategoryId].questions;
      let guestId = 0;
      if(typeof guestObject != 'undefined' && typeof guestObject.id != 'undefined' && guestObject.id > 0) {
        guestId = guestObject.id;
      }
      
      for(const i in cacheListQuestions) {
        let answerId = 0;
        let answer = '';
        if(cacheListQuestions[i].type === 'CHECKBOX') answer = false;
        
        const thisQuestionId = cacheListQuestions[i].id;
        
        if(guestId > 0 && this.cacheAnswers[guestId][thisQuestionId]) {
          answerId = this.cacheAnswers[guestId][thisQuestionId].answerId;
          answer = this.cacheAnswers[guestId][thisQuestionId].answer;
          if(cacheListQuestions[i].type === 'CHECKBOX' && answer == 'false') answer = false;
          if(cacheListQuestions[i].type === 'CHECKBOX' && answer == 'true') answer = true;
        }
        
        const thisQuestion = {
          questionId: thisQuestionId,
          label: cacheListQuestions[i].label,
          type: cacheListQuestions[i].type,
          priceValue: cacheListQuestions[i].priceValue,
          answerId: answerId,
          answer: answer
        };
        
        guestQuestions.push(thisQuestion);
      }
      
      let id = 0;
      let firstname = '';
      let lastname = '';
      let feeSelectedIndex = 0;
      if(guestId > 0) {
        id = guestId;
        firstname = guestObject.firstname;
        lastname = guestObject.lastname;
        feeSelectedIndex = guestObject.feeSelectedIndex;
      }else if (this.isAdmin){
        lastname = this.subscription.lastName;
      }
      
      return {
        id: id,
        firstname: firstname,
        lastname: lastname,
        questions: guestQuestions,
        feeSelectedIndex
      }
    },
    async fillPageEvent(){
      if (this.eventId > 0){
        getEvent(this.eventId).then(async resEvent=>{
          if(resEvent.data) {
            this.event = resEvent.data;

            this.meta.title = this.event.name + ' - ' +this.event.site.name ;
            if (document && document.title) document.title = this.meta.title;
            const date = new Date(this.event.date);
            this.event.date = date.getFullYear()+'-'+(date.getMonth()+1<10?('0'+(date.getMonth()+1)):(date.getMonth()+1))+'-'+((date.getDate()<10)?('0'+date.getDate()):date.getDate());
            
            await getEventGuestCategoryQuestions(this.eventId).then(res=>{
              if(res.data) {
                this.guestCategories = res.data;
                // update cache
                const thisCacheGuestCategoriesQuestions = {};
                for(const i in this.guestCategories) {
                  const thisQuestions = {questions: [], id: this.guestCategories[i].id};
                  
                  for(const j in this.guestCategories[i].questions) {
                    const thisQuestion = {
                      id: this.guestCategories[i].questions[j].id,
                      label: this.guestCategories[i].questions[j].questionLabel,
                      type: this.guestCategories[i].questions[j].questionType,
                      priceValue: this.guestCategories[i].questions[j].priceValue,
                      answer: ''
                    };
                    
                    thisQuestions.questions.push(thisQuestion);
                  }
                  
                  thisCacheGuestCategoriesQuestions[this.guestCategories[i].id] = thisQuestions;
                }
                this.cacheGuestCategoriesQuestions = thisCacheGuestCategoriesQuestions;
                
                // update form subscription
                if(this.subscriptionId > 0) { // edit subscription
                  getSubscription(this.subscriptionId).then(res=>{
                    if(res.data) {
                      this.fillSubscriptionForm(res.data);
                    } else if(res.error) {
                      this.eventError = 'Erreur. Impossible de récupérer les données de l\'inscription.'
                    }
                  });
                } else { // add subscription
                  const thisSubscription = {guestCategories: [], id: 0, paymentOptionsId: 0};
                  for(const i in this.guestCategories) {
                    const thisSubscriptionGuestCategory = {
                      id: this.guestCategories[i].id,
                      number: 0,
                      name: this.guestCategories[i].name,
                      guests: [
                        //this.generateGuestObject(this.guestCategories[i].id, {})
                      ]
                    };
                    
                    thisSubscription.guestCategories.push(thisSubscriptionGuestCategory);
                  }
                  this.subscription = thisSubscription;
                }
              } else if(res.error) {
                this.eventError = 'Erreur. Impossible de récupérer les données questions.'
              }
            });

            await getEventsPaymentOptions(this.eventId).then(res=>{
              if(res.data) {
                this.paymentOptions = res.data;
                if (res.data.length > 0)
                  this.subscription.paymentOptionsId = res.data[0].id;

              } else if(res.error) {
                this.eventError = 'Erreur. Impossible de récupérer les données pour le paiement.'
              }
            });
          } else if(resEvent.error) {
            this.eventError = 'Erreur. Impossible de récupérer les données événements. Inexistant'
          }
        });
      }
    },
    fillSubscriptionForm(data,templateWithoutIds){
      const resSubscription = data;
      
      // create cache objects (of guests and answers) while looping through the guest list
      const guestsByCategories = {};
      const answersByGuestsQuestions = {};
      for(const i in resSubscription.guests) {
        const resSubscriptionGuest = resSubscription.guests[i];
        const guestCategoryId = resSubscriptionGuest.guestCategoryId;
        const guestId = resSubscriptionGuest.id;
        
        for(const j in resSubscriptionGuest.answers) {
          const thisAnswer = resSubscriptionGuest.answers[j];
          const questionId = thisAnswer.questionId;
          
          if(typeof answersByGuestsQuestions[guestId] == 'undefined') answersByGuestsQuestions[guestId] = {};
          answersByGuestsQuestions[guestId][questionId] = templateWithoutIds ? {
            answer: thisAnswer.answer
          } : {
            answerId: thisAnswer.id,
            answer: thisAnswer.answer
          };

          if(thisAnswer.question.questionType == 'FEES' && thisAnswer.answer != "0")
              resSubscriptionGuest.feeSelectedIndex = Number(j);
        }
        
        if(typeof guestsByCategories[guestCategoryId] == 'undefined') guestsByCategories[guestCategoryId] = [];
        const guestCategoryToPush = {
          id: resSubscriptionGuest.id,
          firstname: resSubscriptionGuest.firstName,
          lastname: resSubscriptionGuest.lastName,
          feeSelectedIndex: resSubscriptionGuest.feeSelectedIndex
        };
        guestsByCategories[guestCategoryId].push(guestCategoryToPush);
      }
      this.cacheAnswers = answersByGuestsQuestions;
      
      // recreate the subscription object used for the UI
      const thisSubscription = {
        guestCategories: [], 
        id: resSubscription.id, 
        email: resSubscription.email, 
        firstName: resSubscription.firstName,
        lastName: resSubscription.lastName,
        phonenumber: resSubscription.phoneNumber,
        paymentOptionsId: resSubscription.paymentOptionsId,
        paymentStatus: resSubscription.paymentStatus || '',
        paymentRef: resSubscription.paymentRef || '',
        paymentAmount: resSubscription.paymentAmount,
        organization: resSubscription.organization || '',
        checkedIn: resSubscription.checkedIn
        };
      
      if (templateWithoutIds) delete thisSubscription.id ;

      for(const i in this.guestCategories) {
        const thisCategoryId = this.guestCategories[i].id;
        let thisGuests = [];
        if(typeof guestsByCategories[thisCategoryId] != 'undefined') {
          thisGuests = guestsByCategories[thisCategoryId];
        }
        const guests = [];
        
        for(const j in thisGuests) {
          const thisGuest = thisGuests[j];

          guests.push(this.generateGuestObject(thisCategoryId, thisGuest));
          this.totalGuestsCounter++;
        }
        const thisSubscriptionGuestCategory = {
          id: thisCategoryId,
          number: thisGuests.length,
          name: this.guestCategories[i].name,
          guests: guests
        };
        
        thisSubscription.guestCategories.push(thisSubscriptionGuestCategory);
      }
      this.subscription = thisSubscription;
      this.checkedInOk = this.subscription.checkedIn;
      if (!this.subscription.checkedIn && moment().diff(moment(this.event.date), 'days') == 0) this.subscription.checkedIn = true;
    },
    checkPageRights(){
      if (localStorage.getItem('user-token')){
        this.isAdmin = true;
      }
      if (this.$route.query.id_event){
        this.eventId = this.$route.query.id_event;
        if (this.$route.query.id_subscription){
          this.subscriptionId = this.$route.query.id_subscription;
          this.editionMode = true;
          this.saveButtonLabel= 'Modifier l\'inscription';
        }
      }
    },
    // async startPayment(){
    //   if (this.validForm()){
    //     this.openSumupWidget = true;
    //     this.paymentMessage = 'Préparation du paiement en ligne...';
    //     await this.sendForm();

    //     if (this.checkoutId && this.checkoutId != ''){
    //       window.sumupInstance = window.SumUpCard.mount({
    //         checkoutId: this.checkoutId,
    //         showEmail: true,
    //         email: this.subscription.email,
    //         currency: 'EUR',
    //         locale: 'fr-FR',
    //         amount: this.subscription.paymentAmount,
    //         onResponse: function (type, body) {
    //           console.log('Type', type);
    //           console.log('Body', body);
    //           if (type === 'sent'){
    //             document.getElementById('sumup-card').disabled = true;
    //             document.getElementById('sumup-message')?.innerHTML = 'Traitement de la transaction par SumUp'
    //           }
    //           if (type === 'invalid'){
    //             document.getElementById('sumup-card').disabled = false;
    //             document.getElementById('sumup-message')?.innerHTML = 'Les informations de paiement sont invalides.';
    //           }
    //           if (type === 'error'){
    //             window.sumupInstance.unmount();
    //             document.getElementById('sumup-message')?.innerHTML = "Nous ne pouvons pas traiter le paiement en ligne pour le moment. Néanmoins votre inscription a été enregistrée, nous vous recontacterons pour valider votre inscription et payment."
    //           }
    //           if (type === 'success'){
    //             window.sumupInstance.unmount();
    //             document.getElementById('sumup-message')?.innerHTML = 'Le paiement a été traité avec success. Votre inscription est validée. Nous vous enverrons un email dans les prochains jours avec les informations nécessaires. L\'équipe EMA'
    //           }
    //         },
    //         onLoad: function() {
    //           console.log('LOADED ! ')
    //           document.getElementById('sumup-message')?.innerHTML = ''
    //         }
    //       });
    //     }else{
    //       this.paymentMessage = "Nous ne pouvons pas traiter le paiement en ligne pour le moment. Votre inscription a été enregistrée, nous vous recontacterons pour valider votre inscription."
    //     }
    //   }
    // }
  },
  mounted: function() {
    this.checkPageRights();
    this.fillPageEvent(this.eventId, this.subscriptionId);
  }
})
